import { Component } from 'react';
import '../../../../styles/components/auth.scss';
import { Loader2, Lock, LogIn, UserRound } from 'lucide-react';
import { loginUser } from './services/authService';
import { toast } from 'react-toastify';
import { withRouter } from '../../../../hoc/withRouter';
import { baseUrl } from '../../../../constants/global';
import { Link } from 'react-router-dom';
import i18n from '../../../../i18n';

class LoginNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameOrEmail: null,
      password: null,
      showPassword: false,
      errors: {},
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  validateForm = () => {
    const errors = {};
    const { usernameOrEmail, password } = this.state;

    if (!usernameOrEmail) errors.usernameOrEmail = 'username or email is required';

    if (!password) errors.password = 'password is required';
    if (password.length < 8) {
      errors.password = 'Password must be at least 8 characters';
    }

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };

  renderFieldError = (fieldName) => {
    if (this.state.errors[fieldName]) {
      return <div className="field-error">{this.state.errors[fieldName]}</div>;
    }
    return null;
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    if (!this.validateForm()) {
      return;
    }

    const { usernameOrEmail, password } = this.state;
    this.setState({ isLoading: true });
    try {
      const result = await loginUser({ login: usernameOrEmail, password });

      const { response } = result;
      // Check if verification is required (OTP/email)

      if (response?.data?.requires_verification) {
        // toast.info('Please verify your OTP to continue');
        this.props.navigate(`/login/otp-verify-email/${response.data.verification_token}`, {
          state: {
            data: response.data.email,
            type: 'email',
          },
        });

        return;
      }
      toast.success(response?.message || 'Login successful!');

      this.redirectUser(response?.data?.user?.role);
    } catch (error) {
      toast.error(error.message || 'Login failed. Please try again.');
    } finally {
      this.setState({ isLoading: false });
    }
  };

  // Redirect based on user role
  redirectUser = (role) => {
    if (role === 'A') {
      window.location.href = '/dashboard';
    } else {
      window.location.href = '/';
    }
  };

  handleOTPLogin = () => {
    this.props.navigate(`/login/otp`);
  };

  handleRegisterBidder = () => {
    this.props.navigate(`/register`);
  };

  handleRegisterClient = () => {
    this.props.navigate(`/client-registration`);
  };

  render() {
    const { usernameOrEmail, password, showPassword, isLoading, errors } = this.state;

    return (
      <div className="register-container">
        <div className="login-left-section">
          <div className="auth-content">
            <div className="accent-line"></div>
            <h1 className="title">
              {i18n.t('login_banner_title')}{' '}
              <span className="highlight-l2">{i18n.t('login_banner_title_b')}</span>,{' '}
              {i18n.t('login_banner_title_c')}
            </h1>
            <p className="subtitle-l2">{i18n.t('login_banner_subtitle')}</p>
          </div>
        </div>

        <div className="login-right-section">
          <div className="login-card">
            <h3 className="welcome-title">{i18n.t('login_card_title')}</h3>
            <p className="welcome-subtitle">{i18n.t('login_card_subtitle')}</p>

            <form onSubmit={this.handleSubmit}>
              <div className="form-group-l2">
                <label htmlFor="usernameOrEmail">{i18n.t('username_or_email')}</label>
                <div className="input-wrapper">
                  <UserRound strokeWidth={1.5} className="input-icon-l2" />
                  <input
                    type="text"
                    id="usernameOrEmail"
                    name="usernameOrEmail"
                    value={usernameOrEmail}
                    onChange={this.handleInputChange}
                    placeholder={i18n.t('validate_username')}
                    className={`form-input-l2 ${errors?.usernameOrEmail ? 'error' : ''}`}
                  />
                </div>
                {this.renderFieldError('usernameOrEmail')}
              </div>

              <div className="form-group-l2">
                <label htmlFor="password">{i18n.t('password')}</label>
                <div className="input-wrapper">
                  <Lock strokeWidth={1.5} className="input-icon-l2" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={password}
                    onChange={this.handleInputChange}
                    placeholder={i18n.t('validate_password')}
                    className={`form-input-l2 ${errors?.password ? 'error' : ''}`}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={this.togglePasswordVisibility}
                    aria-label="Toggle password visibility"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      {!showPassword ? (
                        <>
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                          <line x1="1" y1="1" x2="23" y2="23" />
                        </>
                      ) : (
                        <>
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                          <circle cx="12" cy="12" r="3" />
                        </>
                      )}
                    </svg>
                  </button>
                </div>
                {this.renderFieldError('password')}
              </div>

              <div className="form-links">
                <Link to="/forgot-password" className="link link-with-arrow">
                  {i18n.t('forget_password')}
                </Link>
                <a
                  href={`${baseUrl}/guide/login.pdf`}
                  target="_new"
                  className="link link-with-arrow"
                >
                  {i18n.t('user_guide')}
                  <svg
                    className="arrow-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M7 17L17 7M17 7H7M17 7v10" />
                  </svg>
                </a>
              </div>

              <div className="auth-action-buttons">
                <button
                  type="submit"
                  disabled={isLoading}
                  className="button1 button1-gradient full-width"
                >
                  {i18n.t('login')}
                  {isLoading ? <Loader2 className="animate-spin" /> : <LogIn strokeWidth={1.5} />}
                </button>
                <button
                  type="button"
                  className="button1 button1-secondary full-width"
                  onClick={this.handleOTPLogin}
                >
                  {i18n.t('login_with_otp')}
                </button>
              </div>

              <div className="register-section">
                <p className="register-text">{i18n.t('dont_have_an_account')}</p>
                <div className="register-buttons">
                  <button
                    type="button"
                    onClick={this.handleRegisterBidder}
                    className="button1 button1-outline"
                  >
                    {i18n.t('register_bidder')}
                  </button>
                  <button
                    type="button"
                    onClick={this.handleRegisterClient}
                    className="button1 button1-outline"
                  >
                    {i18n.t('register_client')}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LoginNew);
